// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-card {
  margin: 24px;
  border-radius: 16px;
  background: white;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.1);
  transition: transform 0.25s ease, box-shadow 0.25s ease;
}

ion-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.15);
}

ion-card-header {
  background: transparent;
  padding: 20px;
}
ion-card-header ion-card-title {
  font-size: 1.4rem;
  font-weight: 600;
  color: var(--ion-color-primary);
  display: flex;
  align-items: center;
  gap: 10px;
}
ion-card-header ion-card-title ion-icon {
  font-size: 1.5rem;
  color: var(--ion-color-primary);
}

ion-card-content {
  padding: 24px;
}
ion-card-content ion-item {
  --background: transparent;
  --inner-border-width: 0;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  margin-bottom: 20px;
  transition: border-color 0.3s, box-shadow 0.3s;
}
ion-card-content ion-item:focus-within {
  border-color: var(--ion-color-primary);
  box-shadow: 0 0 0 3px rgba(var(--ion-color-primary-rgb), 0.2);
}
ion-card-content ion-item ion-label {
  font-weight: 500;
  color: #444;
  font-size: 0.95rem;
}
ion-card-content ion-item ion-input, ion-card-content ion-item ion-textarea {
  padding: 12px;
  font-size: 1rem;
}
ion-card-content ion-item ion-icon {
  color: var(--ion-color-medium);
  font-size: 1.2rem;
  margin-right: 8px;
}
ion-card-content ion-text {
  font-size: 0.8rem;
  margin: -10px 0 16px 4px;
  color: var(--ion-color-danger);
  display: flex;
  align-items: center;
}
ion-card-content ion-text ion-icon {
  font-size: 0.9rem;
  margin-right: 5px;
}
ion-card-content ion-button {
  margin-top: 24px;
  --border-radius: 12px;
  font-weight: 600;
  height: 48px;
  --box-shadow: 0 4px 14px rgba(var(--ion-color-primary-rgb), 0.3);
  transition: transform 0.2s, box-shadow 0.2s;
}
ion-card-content ion-button:hover:not([disabled]) {
  transform: scale(1.02);
  --box-shadow: 0 6px 20px rgba(var(--ion-color-primary-rgb), 0.4);
}
ion-card-content ion-button[disabled] {
  opacity: 0.6;
}

/* Responsive */
@media (max-width: 576px) {
  ion-card {
    margin: 16px;
    border-radius: 14px;
  }
  ion-card-content {
    padding: 18px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/shared/report/report.component.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,mBAAA;EACA,iBAAA;EACA,2BAAA;EACA,mCAAA;EACA,0CAAA;EACA,yCAAA;EACA,uDAAA;AACF;;AAEA;EACE,2BAAA;EACA,2CAAA;AACF;;AAEA;EACE,uBAAA;EACA,aAAA;AACF;AACE;EACE,iBAAA;EACA,gBAAA;EACA,+BAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;AACJ;AACI;EACE,iBAAA;EACA,+BAAA;AACN;;AAIA;EACE,aAAA;AADF;AAGE;EACE,yBAAA;EACA,uBAAA;EACA,yBAAA;EACA,mBAAA;EACA,mBAAA;EACA,8CAAA;AADJ;AAGI;EACE,sCAAA;EACA,6DAAA;AADN;AAII;EACE,gBAAA;EACA,WAAA;EACA,kBAAA;AAFN;AAKI;EACE,aAAA;EACA,eAAA;AAHN;AAMI;EACE,8BAAA;EACA,iBAAA;EACA,iBAAA;AAJN;AAQE;EACE,iBAAA;EACA,wBAAA;EACA,8BAAA;EACA,aAAA;EACA,mBAAA;AANJ;AAQI;EACE,iBAAA;EACA,iBAAA;AANN;AAUE;EACE,gBAAA;EACA,qBAAA;EACA,gBAAA;EACA,YAAA;EACA,gEAAA;EACA,2CAAA;AARJ;AAUI;EACE,sBAAA;EACA,gEAAA;AARN;AAWI;EACE,YAAA;AATN;;AAcA,eAAA;AACA;EACE;IACE,YAAA;IACA,mBAAA;EAXF;EAcA;IACE,aAAA;EAZF;AACF","sourcesContent":["ion-card {\r\n  margin: 24px;\r\n  border-radius: 16px;\r\n  background: white;\r\n  backdrop-filter: blur(10px);\r\n  -webkit-backdrop-filter: blur(10px);\r\n  border: 1px solid rgba(255, 255, 255, 0.2);\r\n  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.1);\r\n  transition: transform 0.25s ease, box-shadow 0.25s ease;\r\n}\r\n\r\nion-card:hover {\r\n  transform: translateY(-4px);\r\n  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.15);\r\n}\r\n\r\nion-card-header {\r\n  background: transparent;\r\n  padding: 20px;\r\n\r\n  ion-card-title {\r\n    font-size: 1.4rem;\r\n    font-weight: 600;\r\n    color: var(--ion-color-primary);\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 10px;\r\n\r\n    ion-icon {\r\n      font-size: 1.5rem;\r\n      color: var(--ion-color-primary);\r\n    }\r\n  }\r\n}\r\n\r\nion-card-content {\r\n  padding: 24px;\r\n\r\n  ion-item {\r\n    --background: transparent;\r\n    --inner-border-width: 0;\r\n    border: 1px solid #e2e8f0;\r\n    border-radius: 10px;\r\n    margin-bottom: 20px;\r\n    transition: border-color 0.3s, box-shadow 0.3s;\r\n\r\n    &:focus-within {\r\n      border-color: var(--ion-color-primary);\r\n      box-shadow: 0 0 0 3px rgba(var(--ion-color-primary-rgb), 0.2);\r\n    }\r\n\r\n    ion-label {\r\n      font-weight: 500;\r\n      color: #444;\r\n      font-size: 0.95rem;\r\n    }\r\n\r\n    ion-input, ion-textarea {\r\n      padding: 12px;\r\n      font-size: 1rem;\r\n    }\r\n\r\n    ion-icon {\r\n      color: var(--ion-color-medium);\r\n      font-size: 1.2rem;\r\n      margin-right: 8px;\r\n    }\r\n  }\r\n\r\n  ion-text {\r\n    font-size: 0.8rem;\r\n    margin: -10px 0 16px 4px;\r\n    color: var(--ion-color-danger);\r\n    display: flex;\r\n    align-items: center;\r\n\r\n    ion-icon {\r\n      font-size: 0.9rem;\r\n      margin-right: 5px;\r\n    }\r\n  }\r\n\r\n  ion-button {\r\n    margin-top: 24px;\r\n    --border-radius: 12px;\r\n    font-weight: 600;\r\n    height: 48px;\r\n    --box-shadow: 0 4px 14px rgba(var(--ion-color-primary-rgb), 0.3);\r\n    transition: transform 0.2s, box-shadow 0.2s;\r\n\r\n    &:hover:not([disabled]) {\r\n      transform: scale(1.02);\r\n      --box-shadow: 0 6px 20px rgba(var(--ion-color-primary-rgb), 0.4);\r\n    }\r\n\r\n    &[disabled] {\r\n      opacity: 0.6;\r\n    }\r\n  }\r\n}\r\n\r\n/* Responsive */\r\n@media (max-width: 576px) {\r\n  ion-card {\r\n    margin: 16px;\r\n    border-radius: 14px;\r\n  }\r\n\r\n  ion-card-content {\r\n    padding: 18px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
